import {
	TFinalizeInvoiceRequest,
	TInvoice,
	TInvoiceDetail,
	TInvoiceListFilters,
	TInvoiceListResponse,
	TInvoicePrefill,
	TInvoiceSummary,
	TSaveInvoiceRequest,
	TUpdateInvoiceRequest,
} from "@/types";

import API from "./api";

class InvoicesServiceClass {
	list(filters?: TInvoiceListFilters) {
		return API.get<TInvoiceListResponse>(`/invoices`, {
			params: filters,
		}).then((resp) => resp.data);
	}

	summary() {
		return API.get<TInvoiceSummary>(`/invoices/summary`).then(
			(resp) => resp.data
		);
	}

	get(id: number) {
		return API.get<TInvoiceDetail>(`/invoices/${id}`).then(
			(resp) => resp.data
		);
	}

	/** A form's initial values from a finalized report — nothing is saved. */
	prefill(reportId: number) {
		return API.get<TInvoicePrefill>(`/invoices/prefill`, {
			params: { reportId },
		}).then((resp) => resp.data);
	}

	nextNumber(companyId: number) {
		return API.get<{ number: string }>(`/invoices/next-number`, {
			params: { companyId },
		}).then((resp) => resp.data.number);
	}

	create(values: TSaveInvoiceRequest) {
		return API.post<TInvoiceDetail>(`/invoices`, values).then(
			(resp) => resp.data
		);
	}

	update(id: number, values: TUpdateInvoiceRequest) {
		return API.patch<TInvoiceDetail>(`/invoices/${id}`, values).then(
			(resp) => resp.data
		);
	}

	finalize(id: number, values: TFinalizeInvoiceRequest = {}) {
		return API.post<TInvoiceDetail>(
			`/invoices/${id}/finalize`,
			values
		).then((resp) => resp.data);
	}

	setPaid(id: number, paid: boolean) {
		return this.update(id, { paid });
	}

	delete(id: number) {
		return API.delete(`/invoices/${id}`);
	}

	generateById(id: number) {
		return API.post(`/invoices/${id}/generate`, undefined, {
			responseType: "blob",
		});
	}

	/** The template's props as the form holds them: the API does not resolve anything. */
	preview(payload: Record<string, unknown>) {
		return API.post<Blob>(`/invoices/preview`, payload, {
			responseType: "blob",
		});
	}
}

export type { TInvoice };

const InvoicesService = new InvoicesServiceClass();
export default InvoicesService;
